export enum MediaTypeEnum {
  LOGO = 'logo',
  BANNER = 'banner',
  AVATAR = 'avatar',
  MEDIA = 'media',
  VIDEO = 'video',
  BRAND = 'brand',
  BLUEPRINT = 'blueprint',
}
